<div class="landing-page">
  <section class="hero" style="background-image:url('assets/img/Background formulaire candidature Force-N.jpeg')">
    <div class="overlay">
      <div class="logos">
        <ng-container *ngFor="let block of imageBlocks">
          <div *ngIf="paramValue === block.condition" class="logo-container">
            <img *ngFor="let image of block.images" [src]="image" class="logo-image" alt="Logo">
          </div>
        </ng-container>
      </div>
      <h1>
        Bienvenue
      </h1>
      <p>
        Choisissez le programme qui vous intéresse
      </p>
    </div>
  </section>
  <section class="choice-section">
    <div class="cards">
      <div class="choice-card" (click)="goFormation()">
        <div class="icon">
          🎓
        </div>
        <h2>Formations</h2>
        <p>
          Développez vos compétences grâce à nos
          programmes certifiants.
        </p>
        <button>
          S'inscrire →
        </button>
      </div>
      <div class="choice-card" (click)="goEntreprenariat()">
        <div class="icon">
          🚀
        </div>
        <h2>Entrepreneuriat</h2>
        <p>
          Lancez votre projet avec un accompagnement
          personnalisé.
        </p>
        <button>
          S'inscrire →
        </button>
      </div>
    </div>
  </section>
</div>